import React, { useState } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";

function TabPanel(props) {
  const { children, value, index, display, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Grid>{children}</Grid>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    // outline: '1px solid black'
  },

  paper: {
    // outline: '1px solid red',
  },

  extra0: {
    height: 416,
    scrollbarWidth: 'thin',
    overflowX: 'auto',
    overflowY: 'hidden',
    // outline: '1px solid black',
    // backgroundColor: '#FF0000',
    // marginTop: 36
  },

  extra1: {
    height: 416,
    scrollbarWidth: 'thin',
    overflowY: 'auto',
    // outline: '1px solid black',
    backgroundColor: '#00FF00',
    marginTop: 36
  },

  extra2: {
    height: 416,
    scrollbarWidth: 'thin',
    overflowY: 'auto',
    // outline: '1px solid black',
    backgroundColor: '#0000FF',
    marginTop: 36
  },

  dops: {
    height: 232,
    // outline: '1px solid black',
    backgroundColor: '#00FFFF',
    marginTop: 34
  },
}));

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 100,
      width: "100%",
      backgroundColor: "#24262A"
    }
  }
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const CustomTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    color: '#8987A2',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    '&:focus': {
      opacity: 1,
      color: '#24262A',
    },
    '&.Mui-selected': {
      color: '#24262A'
    }
  },
}))((props) => <Tab disableRipple {...props} />);

export default function AppCardTab(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <React.Fragment>
      {/* <Paper className={classes.paper}> */}
      <StyledTabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered
      >
        <CustomTab style={{ display: props.display0 ? '' : 'none' }} label={props.theader0} {...a11yProps(0)} />
        <CustomTab style={{ display: props.display1 ? '' : 'none' }} label={props.theader1} {...a11yProps(1)} />
        <CustomTab style={{ display: props.display2 ? '' : 'none' }} label={props.theader2} {...a11yProps(2)} />

      </StyledTabs>
      {/* </Paper> */}

      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel
          value={value}
          index={0}
          dir={theme.direction}
          className={clsx(classes.content, {
            [classes.extra0]: props.block === 'extra',
            [classes.dops]: props.block === 'dops',
            // [classes.contentClose]: !props.open
          })}
        >
          {/* {props.content0 !== null ?
            <img style={{ width: '100%' }} src={`https://catalog-test.cft.ru/${props.content0}`} onClick={()=>console.log('click')} />
            :
            ''
          } */}
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            style={{ width: "max-content" }}
          >
            {props.content0}
          </Grid>
        </TabPanel>

        <TabPanel
          value={value}
          index={1}
          dir={theme.direction}
          className={clsx(classes.content, {
            [classes.extra1]: props.block === 'extra',
            [classes.dops]: props.block === 'dops',
            // [classes.contentClose]: !props.open
          })}
        >
          {props.content1}
        </TabPanel>

        <TabPanel
          value={value}
          index={2}
          dir={theme.direction}
          className={clsx(classes.content, {
            [classes.extra2]: props.block === 'extra',
            [classes.dops]: props.block === 'dops',
            // [classes.contentClose]: !props.open
          })}
        >
          {props.content2}
        </TabPanel>
      </SwipeableViews>
    </React.Fragment>
  );
}